import { render, staticRenderFns } from "./FunctionTest.vue?vue&type=template&id=0928e75c&"
import script from "./FunctionTest.vue?vue&type=script&lang=ts&"
export * from "./FunctionTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports